import { render, staticRenderFns } from "./DatasetSourceTransform.vue?vue&type=template&id=519cca71&scoped=true"
import script from "./DatasetSourceTransform.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetSourceTransform.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DatasetSourceTransform.vue?vue&type=style&index=0&id=519cca71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519cca71",
  null
  
)

export default component.exports